import script from "./SkillsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./SkillsTab.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__